class Payment {
  constructor({ option }) {
    if (option !== "Full")
      throw new Error(`Payment option : [${option}] is not supported`);
    this.option = option;
    this.paymentChannels = [];
  }

  addChannel(paymentChannel) {
    this.paymentChannels.push(paymentChannel);
  }

  removeChannel(removePaymentChannel) {
    this.paymentChannels = this.paymentChannels.filter(
      (paymentChannel) => paymentChannel !== removePaymentChannel
    );
  }

  removeAllChannels() {
    this.paymentChannels.length = 0;
  }

  addPaidAmount(paidAmount) {
    this.paidAmount = paidAmount;
  }

  getPayloadforPayment() {
    if (!this.paidAmount) throw new Error("Need to add paidamount first");
    return {
      option: this.option,
      paid_amount: this.paidAmount,
      payment_channels: this.paymentChannels.map((paymentChannel) =>
        paymentChannel.getPayloadforPayment()
      ),
    };
  }
}

class PaymentChannel {
  constructor({
    type,
    amount,
    instituteId,
    instituteName,
    cardId,
    cardName,
    image,
    senderInstituteId,
    senderInstituteName,
  }) {
    this.type = type;
    this.amount = amount;
    if (instituteId) this.instituteId = instituteId;
    if (instituteName) this.instituteName = instituteName;
    if (cardId) this.cardId = cardId;
    if (cardName) this.cardName = cardName;
    if (image) this.image = image;
    if (senderInstituteId) this.senderInstituteId = senderInstituteId;
    if (senderInstituteName) this.senderInstituteName = senderInstituteName;
  }

  getPayloadforPayment() {
    let payload = {
      type: this.type,
      amount: Number(this.amount),
    };

    if (this.instituteId) payload["institute_id"] = this.instituteId;
    if (this.instituteName) payload["institute_name"] = this.instituteName;
    if (this.cardId) payload["card_id"] = this.cardId;
    if (this.cardName) payload["card_name"] = this.cardName;
    if (this.image) payload["image"] = this.image;
    if (this.senderInstituteId)
      payload["sender"] = {
        institute_id: this.senderInstituteId,
        institute_name: this.senderInstituteName,
      };
    return payload;
  }
}

export default Payment;
export { PaymentChannel };
